function hover(element, className, className2) {
  element.addEventListener("mouseenter", e => element.children[0].classList.add(className));
  element.addEventListener("mouseenter", e => element.children[1].classList.add(className2));
  element.addEventListener("mouseleave", e => element.children[0].classList.remove(className));
  element.addEventListener("mouseleave", e => element.children[1].classList.remove(className2));
}
const cardTitle = document.querySelectorAll(".card");
cardTitle.forEach( function(el) {
  // hover(el, "bg-white", "bg-light");
});

const iframes = document.querySelectorAll("iframe");
iframes.forEach( function(el, index) {
  el.classList.add('embed-responsive-item');
  var iframeParent = el.parentElement;
  var div = document.createElement('div');
  div.classList.add('embed-responsive', 'embed-responsive-16by9');
  iframeParent.insertBefore(div, el);
  div.appendChild(el);
});
const files = document.querySelectorAll(".card-body>a.file");
const icons = {pdf:"fa-file-pdf-o", ppt:"fa-file-powerpoint-o", pptx:"fa-file-powerpoint-o", doc:"fa-file-word-o", docx:"fa-file-word-o", rar: "fa-compress", zip:"fa-compress", xls:"fa fa-file-excel-o", xlsx:"fa fa-file-excel-o", mp4:"fa fa-video-camera", jpg: "fa-file-image-o", jpeg: "fa-file-image-o", gif: "fa-file-image-o", png: "fa-file-image-o"};
const embed = ["jpg", "jpeg", "gif", "png"];
files.forEach( function(el, index) {
  var tmp = el.title.split(".");
  var ext = el.title.split(".").pop().toLowerCase();
  var icon = icons[ext];
  var url = el.getAttribute('href');
  tmp[tmp.length-1] = "";
  var tmp_title = tmp.join("");
  if(embed.indexOf(ext) > -1) {
    el.innerHTML = `<i class="fa ${icon} text-info"></i> &nbsp;${tmp_title}`;
    // var newel = document.createElement('img');
    // newel.src = url; newel.classList.add("img-fluid");
    var newa = document.createElement("a");
    newa.href=url;
    newa.setAttribute("data-lightbox", "image");
    newa.innerHTML = `<img src="${url}" class="img-fluid" style="width:70%;"><div class="clearfix"></div>`;
    el.parentNode.insertBefore(newa, el);
    // } else if( ext == "pdf") {
    //     el.innerHTML = `<br /><i class="fa ${icon} text-info"></i> &nbsp;${tmp_title}`;
    //     var newel = document.createElement('div');
    //     newel.classList.add("ratio", "ratio-16x9");
    //     newel.innerHTML = `<object type='application/pdf' data='${url}' class="w-75"><embed src="${url}" type='application/pdf'></object>`;
    //     el.parentNode.insertBefore(newel, el);
    // } else if (['doc','docx','xls','xlsx','ppt','pptx'].indexOf(ext)) {
    //     el.innerHTML = `<br /><i class="fa ${icon} text-info"></i> &nbsp;${tmp_title}`;
    //     var newel = document.createElement('div');
    //     newel.classList.add("ratio", "ratio-16x9");
    //     newel.innerHTML = `<iframe src="https://docs.google.com/gview?url=` + url + `&embedded=true" type="application/msword">`;
    //     console.log(newel);
    //     el.parentNode.insertBefore(newel, el);
  } else {
    el.innerHTML = `<i class="fa ${icon} text-info"></i> &nbsp;${tmp_title}`;
  };
});
